// import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
// import DiagnosisIcon from 'components/icons/DiagnosisIcon';
// import HomeHealthIcon from 'components/icons/HomeHealthIcon';
// import PillOffIcon from 'components/icons/PillOffIcon';
// import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
// import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';
// import NeurologyIcon from 'components/icons/NeurologyIcon';
// import SunnySnowingIcon from 'components/icons/SunnySnowingIcon';
// import LandslideOutlinedIcon from '@mui/icons-material/LandslideOutlined';
// import BreastFeedingIcon from 'components/icons/BreastFeedingIcon';
// import PulmonologyIcon from 'components/icons/PulmonologyIcon';
// import MicrobiologyIcon from 'components/icons/MicrobiologyIcon';
// import WaterDoIcon from 'components/icons/WaterDoIcon';
// import PetsIcon from '@mui/icons-material/Pets';
import { SvgIconProps, useTheme } from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

const templatesIcons = {
  NIP_RESULT: AccountBalanceOutlinedIcon,
  PFA_RESULT: ArticleOutlinedIcon,
  // NIP: AccountBalanceOutlinedIcon,
  // NAPHS: HealthAndSafetyOutlinedIcon,
  // OHP: DiagnosisIcon,
  // HRP: HomeHealthIcon,
  // AMR: PillOffIcon,
  // ABA_CHIKUNGUNYA: BugReportOutlinedIcon,
  // ABA_YELLOW_FEVER: BugReportOutlinedIcon,
  // ABA_ZIKA: BugReportOutlinedIcon,
  // BBI: BiotechOutlinedIcon,
  // DM: NeurologyIcon,
  // CH_HCFD: SunnySnowingIcon,
  // GET: LandslideOutlinedIcon,
  // POLIO: BreastFeedingIcon,
  // RDX: PulmonologyIcon,
  // RI: PulmonologyIcon,
  // RMERS: PulmonologyIcon,
  // VHF: MicrobiologyIcon,
  // WFBC: WaterDoIcon,
  // ZP: PetsIcon,
};

export type TTemplateIconsCode = keyof typeof templatesIcons;

interface ITemplatesIcon extends SvgIconProps {
  code: TTemplateIconsCode;
}

export const TemplatesIcon: React.FC<ITemplatesIcon> = ({ code, ...rest }) => {
  const theme = useTheme();
  const Component = templatesIcons[code];

  return !!Component ? <Component sx={{ display: 'block', marginInlineEnd: theme.spacing(4) }} {...rest} /> : null;
};
